import { Bookmark, DefaultLinkClick } from '../types';

const parseUrl = (url: string): { domain: string; path: string; fullUrl: string } => {
  try {
    const urlObj = new URL(url);
    return {
      domain: urlObj.hostname.replace('www.', ''),
      path: urlObj.pathname,
      fullUrl: url,
    };
  } catch {
    return {
      domain: '',
      path: url,
      fullUrl: url,
    };
  }
};

const resolveUrl = (url: string): { domain: string; path: string; fullUrl: string } => {
  if (url.startsWith('http') || url.startsWith('//')) {
    return parseUrl(url);
  }

  const fullUrl = new URL(url, window.location.origin).href;
  return parseUrl(fullUrl);
};

export const extractUrlDetails = (
  data: DefaultLinkClick,
): {
  domain: string;
  path: string;
  fullUrl: string;
} => {
  if (!data?.url) {
    return { domain: '', path: '', fullUrl: '' };
  }
  return resolveUrl(data.url);
};

export const linkData = (data: DefaultLinkClick): DefaultLinkClick => {
  const { domain, path, fullUrl } = extractUrlDetails(data);

  const trimmedInnerText = data?.innerText?.trim() || '';
  const trimmedName = data?.name?.trim() || trimmedInnerText;
  const trimmedSocialMedia = data?.socialMedia?.trim() || '';

  return {
    url: fullUrl,
    domain,
    path,
    innerText: trimmedInnerText,
    position: data?.position,
    name: trimmedName,
    type: data?.type,
    socialMedia: trimmedSocialMedia,
    socialInteraction: data?.socialInteraction,
  };
};

export const bookmarkData = (): Bookmark => ({
  items: [],
});
